import React from 'react';
import mainLogo from '../../assets/noaaNCEIRetina.png';
import mainLogoMobile from '../../assets/noaaNCEIMobile.png';
import searchIcon from '../../assets/search-icon.png';

// eslint-disable-next-line react/prefer-stateless-function
export class NCEIHeader extends React.Component {
  render() {
    return (
      <div id="nceiHeader">
        <div id="header">
          <div id="ngdcheader">
            <a
              href="//www.ngdc.noaa.gov/ngdc.html"
              target="_top"
              title="Go to the National Centers for Environmental Information (formerly the National Geophysical Data Center)"
            >
              <img src={mainLogo} alt="NCEI" height="50" width="440" className="desktop" />
              <img src={mainLogoMobile} alt="NCEI" height="50" width="50" className="mobile" />
            </a>
          </div>
          <div id="imageRight">
            <form method="get" action="//search.usa.gov/search" className="sitesearch">
              {/* <span style={{ fontSize: '10px', fontWeight: 'bold', fontFamily: 'Verdana, Arial, Helvetica, sans-serif' }}>Search</span> */}
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label htmlFor="query-field" id="searchString">
                <span style={{ fontSize: '10px', fontWeight: 'bold', fontFamily: 'Verdana, Arial, Helvetica, sans-serif' }}>Search</span>
              </label>
              <input type="hidden" name="affiliate" value="ngdc.noaa.gov" />
              <input type="hidden" name="v:project" value="firstgov" />
              <input type="text" name="query" id="query-field" aria-label="Search" />
              <input type="image" src={searchIcon} alt="Go" />
            </form>
          </div>
        </div>

        <table width="100%" style={{ marginLeft: 'auto', marginRight: 'auto' }} border="0" cellPadding="0" cellSpacing="0" summary="Navigation Layout Table">
          <tbody>
            <tr style={{ visibility: 'hidden', fontSize: '0', margin: '0' }}>
              <th scope="col">Navigation</th>
              <th scope="col">Contact Us</th>
            </tr>
            <tr>
              <td className="topnav">
                <div className="topnav">
                  &nbsp;
                  <a href="//www.noaa.gov/" title="National Oceanic &amp; Atmospheric Administration" className="topnav">NOAA</a>
                  {' '}
                  &gt;
                  {' '}
                  <a href="//www.nesdis.noaa.gov/" title="NOAA Satellite &amp; Information Service" className="topnav">NESDIS</a>
                  {' '}
                  &gt;
                  {' '}
                  <a
                    href="/"
                    title="go to the National Centers for Environmental Information (formerly the National Geophysical Data Center)"
                    className="topnav"
                  >
                    NCEI (formerly NGDC)
                  </a>
                  {' '}
                  &gt;
                  {' '}
                  <a href="/hazard/" title="Natural Hazards" className="topnav">Natural Hazards</a>
                </div>
              </td>
              <td className="topnav">
                <div className="topnav">
                  <a href="mailto:haz.info@noaa.gov" className="topnav">questions</a>
                  &nbsp;
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div className="haznav">
          <span className="haznavlink">
            {' '}
          </span>
        </div>

      </div>
    );
  }
}
